/**
 * Assess whether a given object is a promise.
 * The check tests for the presence of a `.then()` method.
 * @param {any} object The object to test
 * @return {Boolean} Whether the object is a promise
 */
function isPromise(object) {
  return Boolean(object) && (typeof object.then === 'function');
}

module.exports = isPromise;
